<template>
  <ModalDialog v-model="isShow" :level="9">
    <div class="p-5" slot="dialog-content" @click="handleClickContent($event)">
      <h2 v-if="title">{{ title }}</h2>
      <h4 class="description" v-if="description">{{ description }}</h4>
      <hr v-if="title" :class="{ 'mb-0': title !== 'Note' }" />
      <div class="edit-button-container" v-if="onEditCallback">
        <div
          class="edit-button"
          :class="{ 'no-notes': title == 'Note' && !data.client_notes }"
          @click="handleClickEditButton()"
        >
          <i class="material-icons"> edit </i>
        </div>
      </div>
      <DetailSectionRowLayout
        v-if="listFields && listFields.length"
        :modelData="data"
        labelKey="displayLabel"
        :listFields="listFields"
      />
      <DataTable
        v-if="listTableHeaders && listTableHeaders.length"
        :listHeaders="listTableHeaders"
        :listData="listRows"
        :isCandidateTable="false"
        :defaultItemPerPage="50"
        :showCheckbox="false"
      />
      <hr />
      <div class="row">
        <div class="col-lg-2" v-if="optionalButton">
          <div class="button-group-optional">
            <button
              class="mylisting-button secondary-button"
              @click="optionalInfoButton()"
              style=""
            >
              {{ optionalButton }}
            </button>
          </div>
        </div>

        <div class="col" v-if="optionalButton2">
          <div class="button-group-optional">
            <button
              class="mylisting-button secondary-button"
              @click="optionalInfoButton2()"
              style=""
            >
              {{ optionalButton2 }}
            </button>
          </div>
        </div>

        <div class="col">
          <div class="button-group">
            <button
              class="mylisting-button secondary-button"
              @click="closeInfoDialog()"
              style=""
            >
              {{ closeLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ModalDialog>
</template>
<script>
/* This component is used to show info dialog.
To show an info dialog, call this.showInfoDialog(infoObject)
Structure of infoObject:
{
    title: 'String',
    listFields: 'Array',
    data: 'Object',
    closeLabel: 'String', <- This field is optional, if not set, use default: Close
    onCloseCallback: function reference <- This field is optional, if set, the function will be called after close dialog
    onCloseCallbackData: object <- This field is optional, it is parameter of onCloseCallback function
    optionalButton: 'String', <- This field is optional if set shows a button on left side of dialog
    onOptionalCallback: function reference <- this field is optional if set function is called on click
    onOptionalClose: 'Bool', <- Default false, close dialog before option call back function is called
    onOptionalCallbackData: 'object' <- This field is optional, it is parameter of onOptionalCallback function
    optionalButton2: 'String', <- This field is optional if set shows a button on left side of dialog
    onOptionalCallback2: function reference <- this field is optional if set function is called on click
    onOptionalClose2: 'Bool', <- Default false, close dialog before option call back function is called
    onOptionalCallbackData2: 'object' <- This field is optional, it is parameter of onOptionalCallback2 function
}

*/

import ModalDialog from "./ModalDialog";
import DataTable from "../DataTable.vue";

export default {
  name: "InfoDialog",
  data: function () {
    return {
      title: "",
      description: "",
      closeLabel: "",
      onCloseCallback: null,
      onCloseCallbackData: null,
      listFields: [],
      data: {},
      isShow: false,
      listTableHeaders: [],
      listRows: [],
      hasEditIcon: false,
      onEditCallback: null,
      optionalButton: null,
      onOptionalCallback: null,
      onOptionalClose: null,
      onOptionalCallbackData: null,
      optionalButton2: null,
      onOptionalCallback2: null,
      onOptionalClose2: null,
      onOptionalCallbackData2: null,
      onClickContent: null,
    };
  },
  components: {
    ModalDialog,
    DataTable,
  },
  methods: {
    closeInfoDialog() {
      this.isShow = false;
      if (this.onCloseCallback) {
        if (!this.onCloseCallbackData) {
          this.onCloseCallback();
        } else {
          this.onCloseCallback(this.onCloseCallbackData);
        }
      }
      this.showInfoDialog(null);
    },
    optionalInfoButton() {
      if (this.onOptionalClose) {
        this.isShow = false;
      }
      if (this.onOptionalCallback) {
        if (!this.onOptionalCallbackData) {
          this.onOptionalCallback();
        } else {
          this.onOptionalCallback(this.onOptionalCallbackData);
        }
      }
      if (this.onOptionalClose) {
        this.showInfoDialog(null);
      }
      console.log("option");
    },

    optionalInfoButton2() {
      if (this.onOptionalClose2) {
        this.isShow = false;
      }
      if (this.onOptionalCallback2) {
        if (!this.onOptionalCallbackData2) {
          this.onOptionalCallback2();
        } else {
          this.onOptionalCallback2(this.onOptionalCallbackData2);
        }
      }
      if (this.onOptionalClose2) {
        this.showInfoDialog(null);
      }
    },
    handleClickEditButton() {
      if (this.onEditCallback) {
        this.onEditCallback();
      }
    },
    handleClickContent(event) {
      if (this.onClickContent) {
        this.onClickContent(event.target && event.target.id);
      }
    },
  },
  created() {
    this.$store.watch(
      (state) => state.dialogs.infoDialog,
      (value) => {
        if (!value) {
          this.isShow = false;
          this.showInfoDialog(null);
        } else {
          if (this.isShow) {
            return;
          }
          this.title = value.title;
          this.message = value.message;
          this.listFields = value.listFields;
          this.data = value.data;
          if (!value.closeLabel) {
            this.closeLabel = this.getLabelByKeys("BUTTONS.CLOSE");
          } else {
            this.closeLabel = value.closeLabel;
          }
          this.onCloseCallback = value.onCloseCallback;
          this.onCloseCallbackData = value.onCloseCallbackData;
          this.optionalButton = value.optionalButton
            ? value.optionalButton
            : false;
          this.onOptionalCallback = value.onOptionalCallback;
          this.onOptionalClose = value.onOptionalClose
            ? value.onOptionalClose
            : false;
          this.onOptionalCallbackData = value.onOptionalCallbackData;

          this.optionalButton2 = value.optionalButton2
            ? value.optionalButton2
            : false;
          this.onOptionalCallback2 = value.onOptionalCallback2;
          this.onOptionalClose2 = value.onOptionalClose2
            ? value.onOptionalClose2
            : false;
          this.onOptionalCallbackData2 = value.onOptionalCallbackData2;
          this.listTableHeaders = value.listTableHeaders;
          this.listRows = value.listRows;
          this.hasEditIcon = value.hasEditIcon;
          this.onClickContent = value.onClickContent;
          if (value.onEditCallback) {
            this.onEditCallback = value.onEditCallback;
          }
          this.isShow = true;
        }
      },
      { immediate: true }
    );
  },
  watch: {
    isShow: {
      immediate: true,
      handler() {
        if (!this.isShow) {
          this.closeInfoDialog();
        }
      },
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  h2 {
    font-size: 24px;
  }

  h4 {
    font-size: 20px;
  }
}

.button-group {
  text-align: right;
}
.button-group-optional {
  text-align: left;
}

.edit-icon-button {
  position: absolute;
  right: 0;
}

.edit-button-container {
  position: relative;
}
.edit-button-container .edit-button.no-notes {
  top: -14px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/global-dialogs/InfoDialog.vue